import Vue from "vue";
import Vuex from "vuex";
import GlobalStore from "./global";
import UserStore from "./user";
import ConfigStore from "./config";

const modules =
{
    global: new GlobalStore(),
    user: new UserStore(),
    config: new ConfigStore()
};
Vue.use(Vuex);

let store = new Vuex.Store
({
    modules
});

export default store;
